import BaseInput from './BaseInput'

export default class IntegerIput extends BaseInput {
  parse = (v) => {
    const parsed = parseInt(v, 10)
    return Number.isNaN(parsed) ? undefined : parsed
  }

  inputProps = () => ({ type: 'number' })
}
